import { render } from "./ExtractCNC.vue?vue&type=template&id=24a565e6"
import script from "./ExtractCNC.vue?vue&type=script&lang=js"
export * from "./ExtractCNC.vue?vue&type=script&lang=js"

import "./ExtractCNC.vue?vue&type=style&index=0&id=24a565e6&lang=scss"

import exportComponent from "C:\\Users\\john doe\\Documents\\Venice\\vnc\\AgendaBuilder\\agenda\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__